(function () {
  "use strict";

  var STORAGE_KEY = "ta_mc_quote_data_v1";
  var API_URL = "https://api.teleadapt.com/api/v1/subscribers";
  var TURNSTILE_SITE_KEY = "0x4AAAAAAD-flDSBl2AogtQS";
  var TURNSTILE_CONTAINER_ID = "ta-turnstile-v2";
  var STATUS_ELEMENT_ID = "ta-subscribe-status-v2";
  var LOG_PREFIX = "[TA→API]";
  var TURNSTILE_SCRIPT_URL =
    "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
  var REDIRECT_TIMEOUT_MS = 15000;
  var turnstileLoadPromise;
  var subscriptionStarted = false;
  var apiRequestStarted = false;
  var redirectStarted = false;
  var redirectTimeoutId = null;

  function log(method) {
    var args = Array.prototype.slice.call(arguments, 1);
    args.unshift(LOG_PREFIX);
    console[method].apply(console, args);
  }

  function readStoredData() {
    var value;

    try {
      value = sessionStorage.getItem(STORAGE_KEY);
      return value ? JSON.parse(value) : null;
    } catch (error) {
      log("warn", "Could not read stored quote data.", error);
      return null;
    }
  }

  function writeStoredData(data) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } catch (error) {
      log("warn", "Could not store quote data.", error);
    }
  }

  function setStatus(message) {
    var status = document.getElementById(STATUS_ELEMENT_ID);

    if (status) {
      status.textContent = message;
    }
  }

  function failureStatus() {
    setStatus(
      "Your quote was submitted, but newsletter signup could not be completed."
    );
  }

  function redirectToThankYou() {
    if (redirectStarted) {
      return;
    }
    redirectStarted = true;

    if (redirectTimeoutId !== null) {
      window.clearTimeout(redirectTimeoutId);
      redirectTimeoutId = null;
    }

    window.location.assign("/pages/request-quote-thank-you-with-ref");
  }

  function q(selector, root) {
    return (root || document).querySelector(selector);
  }

  function byPlaceholder(needles, root) {
    root = root || document;
    needles = Array.isArray(needles) ? needles : [needles];
    var selector = needles
      .map(function (text) {
        return (
          'input[placeholder*="' +
          text +
          '" i], textarea[placeholder*="' +
          text +
          '" i]'
        );
      })
      .join(",");
    return q(selector, root);
  }

  function byLabel(needle, root) {
    root = root || document;
    needle = (needle || "").toLowerCase();
    var labels = root.querySelectorAll("label");
    var i;
    var text;
    var forId;
    var element;
    var next;

    for (i = 0; i < labels.length; i += 1) {
      text = (labels[i].textContent || "").trim().toLowerCase();
      if (!needle || text.includes(needle)) {
        forId = labels[i].getAttribute("for");
        if (forId) {
          element = root.querySelector("#" + CSS.escape(forId));
          if (element) {
            return element;
          }
        }
        next = labels[i].nextElementSibling;
        while (
          next &&
          next.tagName &&
          !/^(INPUT|TEXTAREA|SELECT)$/i.test(next.tagName)
        ) {
          next = next.nextElementSibling;
        }
        if (next) {
          return next;
        }
      }
    }
    return null;
  }

  function findConsent(root) {
    root = root || document;
    var box = root.querySelector(
      'input[name="subscribe_newsletter"][value="1"]'
    );
    var boxes;
    var i;
    var label;
    var text;

    if (box) {
      return box;
    }

    box = root.querySelector('input[name="subscribe_newsletter"]');
    if (box) {
      return box;
    }

    boxes = root.querySelectorAll('input[type="checkbox"]');
    for (i = 0; i < boxes.length; i += 1) {
      label = boxes[i].closest("label") || boxes[i].parentElement;
      text =
        label && label.textContent
          ? label.textContent.trim().toLowerCase()
          : "";
      if (text.startsWith("yes, i’d like to receive")) {
        return boxes[i];
      }
    }
    return null;
  }

  function ensure(value, fallback) {
    value = (value || "").trim();
    return value ? value : fallback;
  }

  function discoverFields(form) {
    return {
      email:
        q('input[type="email"]', form) ||
        byPlaceholder(["email", "mail"], form) ||
        byLabel("email", form),
      fname:
        byPlaceholder(["first name", "given", "first"], form) ||
        byLabel("first name", form),
      lname:
        byPlaceholder(["last name", "surname", "last"], form) ||
        byLabel("last name", form),
      fullName:
        byPlaceholder(["full name", "your name"], form) ||
        byLabel("full name", form),
      company: byPlaceholder("company", form) || byLabel("company", form),
      title: byPlaceholder("title", form) || byLabel("title", form),
      phone:
        q('input[type="tel"]', form) ||
        byPlaceholder("phone", form) ||
        byLabel("phone", form),
      consent: findConsent(form)
    };
  }

  function fieldValue(field) {
    return field ? field.value.trim() : "";
  }

  function storeCurrentForm(form) {
    var previous = readStoredData() || {};
    var fields = discoverFields(form);
    var fname = fieldValue(fields.fname);
    var lname = fieldValue(fields.lname);
    var fullName = fieldValue(fields.fullName);
    var parts;

    if ((!fname || !lname) && fullName) {
      parts = fullName.split(/\s+/);
      if (!fname) {
        fname = parts[0] || "";
      }
      if (!lname) {
        lname = parts.slice(1).join(" ");
      }
    }

    var data = {
      email: ensure(fieldValue(fields.email), previous.email || ""),
      fname: ensure(fname, previous.fname || "-"),
      lname: ensure(lname, previous.lname || "-"),
      company: ensure(
        fieldValue(fields.company),
        previous.company || ""
      ),
      title: ensure(fieldValue(fields.title), previous.title || ""),
      phone: ensure(fieldValue(fields.phone), previous.phone || ""),
      consent: Boolean(fields.consent && fields.consent.checked),
      sent: previous.sent === true
    };

    writeStoredData(data);
  }

  function initialiseFormPersistence() {
    var form = document.querySelector("#contact_form");

    if (!form) {
      return;
    }

    form.addEventListener("input", function () {
      storeCurrentForm(form);
    });
    form.addEventListener("change", function () {
      storeCurrentForm(form);
    });
  }

  function loadTurnstile() {
    var existingScript;

    if (window.turnstile) {
      return Promise.resolve(window.turnstile);
    }

    if (turnstileLoadPromise) {
      return turnstileLoadPromise;
    }

    turnstileLoadPromise = new Promise(function (resolve, reject) {
      function loaded() {
        if (window.turnstile) {
          resolve(window.turnstile);
        } else {
          reject(new Error("Turnstile loaded without exposing its API."));
        }
      }

      existingScript = document.querySelector(
        'script[src="' + TURNSTILE_SCRIPT_URL + '"]'
      );

      if (existingScript) {
        existingScript.addEventListener("load", loaded, { once: true });
        existingScript.addEventListener(
          "error",
          function () {
            reject(new Error("Turnstile script failed to load."));
          },
          { once: true }
        );
        return;
      }

      existingScript = document.createElement("script");
      existingScript.src = TURNSTILE_SCRIPT_URL;
      existingScript.async = true;
      existingScript.defer = true;
      existingScript.addEventListener("load", loaded, { once: true });
      existingScript.addEventListener(
        "error",
        function () {
          reject(new Error("Turnstile script failed to load."));
        },
        { once: true }
      );
      document.head.appendChild(existingScript);
    });

    return turnstileLoadPromise;
  }

  function submitSubscription(token, stored) {
    return fetch(API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        email: stored.email,
        first_name: stored.fname || "-",
        last_name: stored.lname || "-",
        company: stored.company || "",
        title: stored.title || "",
        phone: stored.phone || "",
        turnstile_token: token
      })
    })
      .then(function (response) {
        return response
          .json()
          .then(function (result) {
            return { response: response, result: result };
          })
          .catch(function (error) {
            throw {
              type: "invalid-json",
              response: response,
              error: error
            };
          });
      })
      .then(function (outcome) {
        if (!outcome.response.ok || outcome.result.success !== true) {
          throw {
            type: "api-failure",
            status: outcome.response.status,
            success: outcome.result && outcome.result.success,
            result: outcome.result && outcome.result.result
          };
        }

        stored.sent = true;
        writeStoredData(stored);
        setStatus("Newsletter signup completed.");
        log("info", "Subscription completed.", {
          status: outcome.response.status,
          success: outcome.result.success
        });
        redirectToThankYou();
      })
      .catch(function (error) {
        failureStatus();
        log("error", "Subscription request failed.", error);
        redirectToThankYou();
      });
  }

  function initialiseSuccessSubscription() {
    var stored;
    var container;

    if (
      new URLSearchParams(window.location.search).get("contact_posted") !==
      "true"
    ) {
      return;
    }

    if (redirectStarted) {
      return;
    }
    if (redirectTimeoutId === null) {
      redirectTimeoutId = window.setTimeout(
        redirectToThankYou,
        REDIRECT_TIMEOUT_MS
      );
    }

    stored = readStoredData();
    if (
      !stored ||
      !stored.email ||
      stored.consent !== true ||
      stored.sent === true
    ) {
      redirectToThankYou();
      return;
    }

    if (subscriptionStarted) {
      return;
    }
    subscriptionStarted = true;

    container = document.getElementById(TURNSTILE_CONTAINER_ID);
    if (!container) {
      failureStatus();
      log(
        "warn",
        "Turnstile container #" + TURNSTILE_CONTAINER_ID + " was not found."
      );
      redirectToThankYou();
      return;
    }

    loadTurnstile()
      .then(function (turnstile) {
        turnstile.render(container, {
          sitekey: TURNSTILE_SITE_KEY,
          theme: "auto",
          callback: function (token) {
            if (apiRequestStarted) {
              return;
            }
            apiRequestStarted = true;
            submitSubscription(token, stored);
          },
          "error-callback": function (code) {
            failureStatus();
            log("error", "Turnstile challenge failed.", code);
            redirectToThankYou();
          },
          "expired-callback": function () {
            failureStatus();
            log("warn", "Turnstile token expired before submission.");
            redirectToThankYou();
          },
          "timeout-callback": function () {
            failureStatus();
            log("warn", "Turnstile challenge timed out.");
            redirectToThankYou();
          }
        });
      })
      .catch(function (error) {
        failureStatus();
        log("error", "Turnstile could not be loaded.", error);
        redirectToThankYou();
      });
  }

  function initialise() {
    initialiseFormPersistence();
    initialiseSuccessSubscription();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialise, { once: true });
  } else {
    initialise();
  }
})();
